import React from "react";
import { BookOpen } from "lucide-react";

/** Page header in the lesson plan creator's style: orange icon, big orange title, blue subtitle. */
export default function ACPPPageHeader({ icon: Icon = BookOpen, title, subtitle }) {
  return (
    <div className="pb-8 pt-4 text-center">
      <div className="mb-5 inline-flex h-16 w-16 items-center justify-center rounded-full" style={{ backgroundColor: "#D67C2C" }}>
        <Icon className="h-8 w-8 text-white" />
      </div>
      <h1 className="mb-3 text-3xl font-bold text-[#D67C2C] sm:text-5xl">{title}</h1>
      {subtitle && <p className="mx-auto max-w-3xl px-4 text-lg font-medium text-[#1D3469] sm:text-xl">{subtitle}</p>}
    </div>
  );
}
